var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-detail" },
    [
      _vm.table && !_vm.loading
        ? _c("TableToolbar", {
            attrs: {
              fields: _vm.tableFields,
              filters: _vm.filterConditions,
              selectedRecords: _vm.selectedRecords,
              "table-id": _vm.tableId,
              table: _vm.table,
              hiddenFields: _vm.hiddenFields,
              lockedFields: _vm.lockedFields,
              sort: _vm.currentSort,
              "current-view": _vm.currentView,
            },
            on: {
              "filter-updated": _vm.onFilterUpdated,
              search: _vm.onSearch,
              "records-deleted": _vm.onRecordsDeleted,
              "records-duplicated": _vm.onRecordsDuplicated,
              "edit-records": _vm.onEditRecords,
              "show-hide-fields": _vm.openHideFieldsPanel,
              "clear-hidden-fields": _vm.showAllFields,
              "view-created": _vm.onViewCreated,
              "show-view": _vm.onShowView,
              "edit-view": _vm.$_.noop,
              "create-new-view": _vm.$_.noop,
              "open-import-modal": _vm.openImportModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-body" },
        [
          _vm.table && !_vm.loading
            ? _c("TableHeaders", {
                attrs: {
                  table: _vm.table,
                  isSelectionModeActive: _vm.isSelectionModeActive,
                  selectedRecords: _vm.selectedRecords,
                  isAllSelected: _vm.isAllSelected,
                  visibleFields: _vm.visibleFields,
                },
                on: {
                  "refresh-table": _vm.fetchTable,
                  "toggle-select-all": _vm.toggleSelectAll,
                  "hide-field": _vm.hideField,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.table && !_vm.loading
            ? _c("TableRecords", {
                attrs: {
                  table: _vm.table,
                  records: _vm.filteredRecords,
                  isSelectionModeActive: _vm.isSelectionModeActive,
                  selectedRecords: _vm.selectedRecords,
                  visibleFields: _vm.visibleFields,
                },
                on: {
                  "record-updated": _vm.recordUpdated,
                  "toggle-selection": _vm.toggleSelection,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "loading-overlay" },
                [_c("a-spin", { attrs: { size: "large" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("TableFooter", {
        attrs: {
          "record-count": _vm.total,
          "table-id": _vm.tableId,
          disabled: _vm.loading || _vm.isCreatingRecord,
        },
        on: {
          "create-new-record": _vm.onCreateNewRecord,
          "open-import-modal": _vm.openImportModal,
        },
      }),
      _vm._v(" "),
      _vm.showEditMultiRecordModal
        ? _c(
            "Modal2",
            {
              attrs: { showFooter: false, title: "Edit Multiple Records" },
              on: { cancel: _vm.closeEditMultiRecordModal },
            },
            [
              _c("EditMultiRecord", {
                attrs: {
                  table: _vm.table,
                  fields: _vm.tableFields,
                  selectedRecords: _vm.selectedRecords,
                },
                on: {
                  "records-updated": _vm.onRecordsUpdated,
                  cancel: _vm.closeEditMultiRecordModal,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showHideFieldsPanel
        ? _c("HideFields", {
            attrs: { fields: _vm.tableFields, hiddenFields: _vm.hiddenFields },
            on: {
              close: _vm.closeHideFieldsPanel,
              "hide-field": _vm.hideField,
              "show-field": _vm.showField,
              "show-all-fields": _vm.showAllFields,
              "hide-all-fields": _vm.hideAllFields,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showImportModal
        ? _c(
            "Modal2",
            {
              staticClass: "import-records-modal",
              attrs: { title: "Kayıtları içeri Aktar", "show-footer": false },
              on: { cancel: _vm.closeImportModal },
            },
            [
              _c("ImportRecords", {
                attrs: {
                  table: _vm.table,
                  fields: _vm.tableFields,
                  "on-completed": _vm.closeImportModal,
                  "on-cancelled": _vm.closeImportModal,
                },
                on: {
                  "import-records": _vm.handleImport,
                  cancel: _vm.closeImportModal,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }